import { isPublicBuylistPage, type PublicBuylistPage } from "@/hooks/usePublicBuylist";
import { isRecord, validatedJson } from "@/lib/ui/validatedJson";

type SavedPublicBuylist = { page: PublicBuylistPage; savedAt: string; };

const CACHE_NAME = "trovie-public-show-artifacts-v1";

function key(slug: string): string {
  return new URL(
    `/__trovie-cache__/shows/buylist/${encodeURIComponent(slug)}`,
    window.location.origin,
  )
    .href;
}

function isSaved(value: unknown): value is SavedPublicBuylist {
  return isRecord(value) && typeof value.savedAt === "string"
    && isPublicBuylistPage(value.page);
}

export async function savePublicBuylist(slug: string, page: PublicBuylistPage): Promise<void> {
  if (!("caches" in window)) return;
  try {
    await (await caches.open(CACHE_NAME)).put(
      key(slug),
      new Response(JSON.stringify({ page, savedAt: new Date().toISOString() }), {
        headers: { "content-type": "application/json" },
      }),
    );
  } catch {
    return;
  }
}

export async function readPublicBuylist(slug: string): Promise<SavedPublicBuylist | null> {
  if (!("caches" in window)) return null;
  try {
    const response = await (await caches.open(CACHE_NAME)).match(key(slug));
    return response ? validatedJson(response, isSaved, "Cached Buylist was invalid") : null;
  } catch {
    return null;
  }
}

export async function deletePublicBuylist(slug: string): Promise<void> {
  if (!("caches" in window)) return;
  try {
    await (await caches.open(CACHE_NAME)).delete(key(slug));
  } catch {
    return;
  }
}
